module.exports = __webpack_public_path__ + "static/media/timelapse_22.5afa8fda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_22.jpg
// module id = 980
// module chunks = 0